var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 280,
    viewBox: "0 0 437 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6029_48873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.145 186.798C103.099 186.798 103.053 186.789 103.007 186.761L0.138198 127.457C0.00947416 127.384 -0.0364987 127.219 0.0370579 127.081C0.110615 126.953 0.276117 126.907 0.414036 126.98L103.154 186.21L233.846 110.866C233.929 110.821 234.03 110.821 234.122 110.866L321.204 161.071L378.651 127.953C378.78 127.88 378.946 127.926 379.028 128.054C379.111 128.183 379.056 128.348 378.927 128.431L321.342 161.631C321.259 161.677 321.158 161.677 321.066 161.631L233.984 111.427L103.292 186.77C103.292 186.77 103.2 186.807 103.154 186.807L103.145 186.798Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.724 225.369C436.678 225.369 436.632 225.36 436.586 225.332L361.494 182.041L314.951 208.879C314.869 208.925 314.758 208.925 314.675 208.879L132.08 103.604C131.998 103.558 131.942 103.466 131.942 103.365C131.942 103.264 131.998 103.181 132.08 103.126L225.442 49.2948C225.571 49.2214 225.736 49.2673 225.819 49.3958C225.893 49.5244 225.847 49.6896 225.718 49.7723L132.761 103.365L314.813 208.319L361.356 181.481C361.439 181.435 361.549 181.435 361.632 181.481L436.862 224.855C436.991 224.928 437.037 225.094 436.963 225.231C436.917 225.314 436.825 225.369 436.724 225.369Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.562 261.609C267.516 261.609 267.47 261.6 267.424 261.572L211.687 229.437C211.604 229.391 211.549 229.299 211.549 229.198C211.549 229.097 211.604 229.014 211.687 228.959L281.014 188.992C281.143 188.919 281.308 188.965 281.391 189.093C281.464 189.222 281.418 189.387 281.29 189.47L212.376 229.198L267.7 261.095C267.829 261.168 267.875 261.333 267.801 261.471C267.755 261.554 267.663 261.609 267.562 261.609Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.091 277.666C349.045 277.666 348.999 277.657 348.953 277.629L47.7935 104.007C47.6647 103.933 47.6188 103.768 47.6923 103.63C47.7659 103.502 47.9314 103.456 48.0693 103.529L349.229 277.152C349.357 277.225 349.403 277.391 349.33 277.528C349.284 277.611 349.192 277.666 349.091 277.666Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.084 203.682C167.038 203.682 166.992 203.673 166.946 203.646L87.9094 158.078C87.8267 158.032 87.7715 157.94 87.7715 157.839C87.7715 157.738 87.8267 157.655 87.9094 157.6L157.237 117.633C157.365 117.56 157.531 117.606 157.614 117.734C157.687 117.863 157.641 118.028 157.512 118.11L88.599 157.839L167.093 203.095L355.371 94.5507C355.499 94.4772 355.665 94.5231 355.748 94.6517C355.821 94.7802 355.775 94.9455 355.646 95.0281L167.24 203.655C167.24 203.655 167.148 203.692 167.102 203.692L167.084 203.682Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M115.134 104.963L91.2373 91.1903L115.134 77.418L139.022 91.1903L115.134 104.963Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.134 89.0987L91.2373 75.3264L115.134 61.5449L139.022 75.3264L115.134 89.0987Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M115.134 76.3819L91.2373 62.6004L115.134 48.8281L139.022 62.6004L115.134 76.3819Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.134 77.0516C115.015 77.0516 114.904 77.024 114.794 76.9597L90.9066 63.1874C90.6951 63.0681 90.5664 62.8385 90.5664 62.5998C90.5664 62.3611 90.6951 62.1316 90.9066 62.0122L114.794 48.2399C115.006 48.1206 115.263 48.1206 115.475 48.2399L139.362 62.0122C139.574 62.1316 139.702 62.3611 139.702 62.5998C139.702 62.8385 139.574 63.0681 139.362 63.1874L115.475 76.9597C115.373 77.024 115.254 77.0516 115.134 77.0516ZM92.5984 62.5998L115.134 75.5917L137.67 62.5998L115.134 49.608L92.5984 62.5998Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M305.187 259.334L281.29 245.561L305.187 231.789L329.074 245.561L305.187 259.334Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.187 260.013C305.068 260.013 304.957 259.985 304.847 259.921L280.959 246.148C280.748 246.029 280.619 245.799 280.619 245.561C280.619 245.322 280.748 245.093 280.959 244.973L304.847 231.201C305.058 231.081 305.316 231.081 305.527 231.201L329.424 244.973C329.635 245.093 329.764 245.322 329.764 245.561C329.764 245.799 329.635 246.029 329.424 246.148L305.536 259.921C305.435 259.985 305.316 260.013 305.196 260.013H305.187ZM282.651 245.561L305.187 258.553L327.723 245.561L305.187 232.569L282.651 245.561Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M358.009 246.239L345.468 239.013L358.009 231.787L370.541 239.013L358.009 246.239Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.009 239.014L345.468 231.788L358.009 224.562L370.541 231.788L358.009 239.014Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M358.009 231.788L345.468 224.562L358.009 217.336L370.541 224.562L358.009 231.788Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.009 246.92C357.89 246.92 357.78 246.892 357.669 246.828L345.137 239.602C344.926 239.483 344.797 239.253 344.797 239.014C344.797 238.776 344.926 238.546 345.137 238.427L357.669 231.201C357.881 231.081 358.138 231.081 358.35 231.201L370.882 238.427C371.093 238.546 371.222 238.776 371.222 239.014C371.222 239.253 371.093 239.483 370.882 239.602L358.35 246.828C358.249 246.892 358.129 246.92 358.009 246.92ZM346.829 239.014L358.009 245.46L369.19 239.014L358.009 232.569L346.829 239.014Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.6709 202.124L71.1387 194.898L83.6709 187.672L96.2031 194.898L83.6709 202.124Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6706 202.802C83.5511 202.802 83.4408 202.775 83.3304 202.711L70.7982 195.485C70.5867 195.365 70.458 195.136 70.458 194.897C70.458 194.658 70.5867 194.429 70.7982 194.31L83.3304 187.084C83.5419 186.964 83.7993 186.964 84.0108 187.084L96.543 194.31C96.7545 194.429 96.8832 194.658 96.8832 194.897C96.8832 195.136 96.7545 195.365 96.543 195.485L84.0108 202.711C83.9097 202.775 83.7902 202.802 83.6706 202.802ZM72.49 194.897L83.6706 201.343L94.8512 194.897L83.6706 188.452L72.49 194.897Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.286 233.541L97.6191 157.628L229.286 81.7246L360.943 157.628L229.286 233.541Z",
    fill: "#0F054C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.285 221.762L118.04 157.629L229.285 93.4961L340.53 157.629L229.285 221.762Z",
    fill: "#0F054C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.286 208.09L141.763 157.628L229.286 107.176L316.8 157.628L229.286 208.09Z",
    fill: "#080344"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.824 51.0759L163.627 42.7207L168.675 132.424L187.542 135.335L201.343 48.551L169.824 51.0759Z",
    fill: "url(#paint2_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.627 42.7202L177.428 34.7598L196.295 37.6703L201.343 48.5504L187.542 56.5108L168.675 53.5911L163.627 42.7202Z",
    fill: "url(#paint3_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.995 42.5098L168.859 52.9675L187.717 55.8781L201.159 48.138L201.343 48.5512L187.542 56.5116L168.675 53.5919L163.627 42.7209L163.995 42.5098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.675 53.5918V132.424L187.542 135.335V56.5115L168.675 53.5918Z",
    fill: "url(#paint4_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.627 42.7207V121.544L168.675 132.424V53.5916L163.627 42.7207Z",
    fill: "url(#paint5_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.343 48.5508V127.374L187.542 135.335V56.5112L201.343 48.5508Z",
    fill: "url(#paint6_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.522 81.4939L193.325 73.1387L198.382 148.602L217.24 151.512L231.051 78.9598L199.522 81.4939Z",
    fill: "url(#paint7_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.325 73.1381L207.135 65.1777L225.994 68.0883L231.051 78.9592L217.24 86.9196L198.382 84.0091L193.325 73.1381Z",
    fill: "url(#paint8_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.693 72.918L198.557 83.3849L217.424 86.2955L230.857 78.5463L231.051 78.9594L217.24 86.9198L198.382 84.0093L193.325 73.1383L193.693 72.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.382 84.0098V148.602L217.24 151.512V86.9203L198.382 84.0098Z",
    fill: "url(#paint9_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.325 73.1387V137.722L198.382 148.602V84.0096L193.325 73.1387Z",
    fill: "url(#paint10_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05 78.959V143.551L217.24 151.511V86.9194L231.05 78.959Z",
    fill: "url(#paint11_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.23 113.785L223.033 105.43L228.081 166.074L246.948 168.984L260.759 111.26L229.23 113.785Z",
    fill: "url(#paint12_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.033 105.429L236.843 97.4688L255.702 100.379L260.759 111.259L246.948 119.22L228.081 116.3L223.033 105.429Z",
    fill: "url(#paint13_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.401 105.219L228.265 115.677L247.123 118.596L260.565 110.847L260.759 111.26L246.948 119.221L228.081 116.301L223.033 105.43L223.401 105.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.081 116.301V166.074L246.948 168.984V119.221L228.081 116.301Z",
    fill: "url(#paint14_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.033 105.43V155.194L228.081 166.074V116.301L223.033 105.43Z",
    fill: "url(#paint15_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.759 111.26V161.024L246.948 168.984V119.22L260.759 111.26Z",
    fill: "url(#paint16_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.929 137.015L252.731 128.65L257.788 183.547L276.647 186.457L290.457 134.481L258.929 137.015Z",
    fill: "url(#paint17_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.731 128.65L266.542 120.689L285.409 123.609L290.457 134.48L276.647 142.441L257.788 139.53L252.731 128.65Z",
    fill: "url(#paint18_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.108 128.439L257.963 138.906L276.83 141.817L290.264 134.068L290.457 134.481L276.647 142.441L257.788 139.531L252.731 128.651L253.108 128.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.788 139.529V183.546L276.646 186.456V142.44L257.788 139.529Z",
    fill: "url(#paint19_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.731 128.65V172.667L257.788 183.547V139.531L252.731 128.65Z",
    fill: "url(#paint20_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.457 134.48V178.497L276.646 186.457V142.441L290.457 134.48Z",
    fill: "url(#paint21_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.637 165.359L282.439 157.004L287.496 201.02L306.355 203.931L320.165 162.825L288.637 165.359Z",
    fill: "url(#paint22_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.439 157.003L296.25 149.043L315.108 151.954L320.165 162.824L306.355 170.785L287.496 167.874L282.439 157.003Z",
    fill: "url(#paint23_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.807 156.783L287.671 167.25L306.529 170.161L319.972 162.411L320.165 162.825L306.355 170.785L287.496 167.874L282.439 157.004L282.807 156.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.496 167.875V201.02L306.354 203.931V170.786L287.496 167.875Z",
    fill: "url(#paint24_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.439 157.004V190.14L287.496 201.02V167.875L282.439 157.004Z",
    fill: "url(#paint25_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.165 162.824V195.97L306.354 203.93V170.785L320.165 162.824Z",
    fill: "url(#paint26_linear_6029_48873)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.824 31.9607L163.627 23.6055L168.675 98.2238L187.542 101.134L201.343 29.4357L169.824 31.9607Z",
    fill: "url(#paint27_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.627 23.6049L177.428 15.6445L196.295 18.5551L201.343 29.4352L187.542 37.3956L168.675 34.4759L163.627 23.6049Z",
    fill: "url(#paint28_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.995 23.3945L168.859 33.8523L187.717 36.7628L201.159 29.0228L201.343 29.436L187.542 37.3964L168.675 34.4766L163.627 23.6057L163.995 23.3945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.675 34.4766V98.2239L187.542 101.134V37.3963L168.675 34.4766Z",
    fill: "url(#paint29_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.627 23.6055V87.3528L168.675 98.2238V34.4764L163.627 23.6055Z",
    fill: "url(#paint30_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.343 29.4355V93.1737L187.542 101.134V37.3959L201.343 29.4355Z",
    fill: "url(#paint31_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.522 62.3786L193.325 54.0234L198.382 115.696L217.24 118.606L231.051 59.8445L199.522 62.3786Z",
    fill: "url(#paint32_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.325 54.0229L207.135 46.0625L225.994 48.973L231.051 59.844L217.24 67.8044L198.382 64.8938L193.325 54.0229Z",
    fill: "url(#paint33_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.693 53.8027L198.557 64.2697L217.424 67.1802L230.857 59.431L231.051 59.8442L217.24 67.8046L198.382 64.894L193.325 54.0231L193.693 53.8027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.382 64.8945V115.696L217.24 118.606V67.8051L198.382 64.8945Z",
    fill: "url(#paint34_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.325 54.0234V104.825L198.382 115.696V64.8944L193.325 54.0234Z",
    fill: "url(#paint35_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05 59.8438V110.645L217.24 118.606V67.8041L231.05 59.8438Z",
    fill: "url(#paint36_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.23 94.6696L223.033 86.3145L228.081 133.168L246.948 136.078L260.759 92.1447L229.23 94.6696Z",
    fill: "url(#paint37_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.033 86.3139L236.843 78.3535L255.702 81.2641L260.759 92.1442L246.948 100.105L228.081 97.1848L223.033 86.3139Z",
    fill: "url(#paint38_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.401 86.1035L228.265 96.5613L247.123 99.481L260.565 91.7318L260.759 92.145L246.948 100.105L228.081 97.1856L223.033 86.3147L223.401 86.1035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.081 97.1855V133.168L246.948 136.079V100.105L228.081 97.1855Z",
    fill: "url(#paint39_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.033 86.3145V122.297L228.081 133.168V97.1854L223.033 86.3145Z",
    fill: "url(#paint40_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.759 92.1445V128.118L246.948 136.078V100.105L260.759 92.1445Z",
    fill: "url(#paint41_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.929 117.9L252.731 109.535L257.788 150.641L276.647 153.551L290.457 115.365L258.929 117.9Z",
    fill: "url(#paint42_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.731 109.535L266.542 101.574L285.409 104.494L290.457 115.365L276.647 123.325L257.788 120.415L252.731 109.535Z",
    fill: "url(#paint43_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M258.938 110.498L268.206 105.154L280.867 107.11L284.259 114.409L274.991 119.753L262.33 117.797L258.938 110.498Z",
    fill: "url(#paint44_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.108 109.324L257.963 119.782L276.83 122.702L290.264 114.952L290.457 115.366L276.647 123.326L257.788 120.416L252.731 109.535L253.108 109.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.788 120.414V150.64L276.646 153.55V123.325L257.788 120.414Z",
    fill: "url(#paint45_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.731 109.535V139.77L257.788 150.641V120.415L252.731 109.535Z",
    fill: "url(#paint46_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.457 115.365V145.591L276.646 153.551V123.326L290.457 115.365Z",
    fill: "url(#paint47_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.929 100.326L252.731 91.9707L257.788 110.646L276.647 113.556L290.457 97.801L258.929 100.326Z",
    fill: "url(#paint48_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.731 91.9702L266.542 84.0098L285.409 86.9203L290.457 97.8004L276.647 105.761L257.788 102.85L252.731 91.9702Z",
    fill: "url(#paint49_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.108 91.7598L257.963 102.218L276.83 105.137L290.264 97.388L290.457 97.8012L276.647 105.762L257.788 102.851L252.731 91.9709L253.108 91.7598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.788 102.85V110.645L276.646 113.555V105.76L257.788 102.85Z",
    fill: "url(#paint50_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.731 91.9707V99.775L257.788 110.646V102.851L252.731 91.9707Z",
    fill: "url(#paint51_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.457 97.8008V105.596L276.646 113.556V105.761L290.457 97.8008Z",
    fill: "url(#paint52_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.637 146.244L282.439 137.889L287.496 168.114L306.355 171.025L320.165 143.71L288.637 146.244Z",
    fill: "url(#paint53_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.439 137.888L296.25 129.928L315.108 132.838L320.165 143.709L306.355 151.67L287.496 148.759L282.439 137.888Z",
    fill: "url(#paint54_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.807 137.668L287.671 148.135L306.529 151.045L319.972 143.296L320.165 143.709L306.355 151.67L287.496 148.759L282.439 137.888L282.807 137.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.496 148.76V168.114L306.354 171.025V151.67L287.496 148.76Z",
    fill: "url(#paint55_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.439 137.889V157.243L287.496 168.114V148.76L282.439 137.889Z",
    fill: "url(#paint56_linear_6029_48873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.165 143.709V163.064L306.354 171.024V151.669L320.165 143.709Z",
    fill: "url(#paint57_linear_6029_48873)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6029_48873",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(366.594 -86.8269) rotate(150.035) scale(85.9021 74.6817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#33AEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#267A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#122E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0C1651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#090747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080344"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6029_48873",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(471.893 172.166) rotate(150.035) scale(58.034 50.4537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#33AEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#267A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#122E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0C1651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#090747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6029_48873",
    x1: 201.352,
    y1: 89.0232,
    x2: 163.627,
    y2: 89.0232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6029_48873",
    x1: 451.613,
    y1: -112.271,
    x2: 424.018,
    y2: -96.3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6029_48873",
    x1: 187.542,
    y1: 94.468,
    x2: 168.684,
    y2: 94.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6029_48873",
    x1: 168.684,
    y1: 87.5725,
    x2: 163.627,
    y2: 87.5725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6029_48873",
    x1: 201.352,
    y1: 91.9427,
    x2: 187.542,
    y2: 91.9427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6029_48873",
    x1: 231.051,
    y1: 112.325,
    x2: 193.334,
    y2: 112.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6029_48873",
    x1: 460.793,
    y1: -69.8044,
    x2: 433.198,
    y2: -53.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6029_48873",
    x1: 217.249,
    y1: 117.761,
    x2: 198.382,
    y2: 117.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6029_48873",
    x1: 198.382,
    y1: 110.866,
    x2: 193.334,
    y2: 110.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6029_48873",
    x1: 231.05,
    y1: 115.235,
    x2: 217.249,
    y2: 115.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6029_48873",
    x1: 260.759,
    y1: 137.207,
    x2: 223.033,
    y2: 137.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6029_48873",
    x1: 469.169,
    y1: -24.9826,
    x2: 441.574,
    y2: -9.02789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6029_48873",
    x1: 246.948,
    y1: 142.643,
    x2: 228.09,
    y2: 142.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6029_48873",
    x1: 228.09,
    y1: 135.747,
    x2: 223.033,
    y2: 135.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6029_48873",
    x1: 260.759,
    y1: 140.117,
    x2: 246.948,
    y2: 140.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6029_48873",
    x1: 290.466,
    y1: 157.554,
    x2: 252.741,
    y2: 157.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6029_48873",
    x1: 481.456,
    y1: 8.46287,
    x2: 453.861,
    y2: 24.4176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6029_48873",
    x1: 276.655,
    y1: 162.988,
    x2: 257.788,
    y2: 162.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6029_48873",
    x1: 257.788,
    y1: 156.103,
    x2: 252.741,
    y2: 156.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6029_48873",
    x1: 290.466,
    y1: 160.473,
    x2: 276.656,
    y2: 160.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6029_48873",
    x1: 320.165,
    y1: 180.463,
    x2: 282.439,
    y2: 180.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6029_48873",
    x1: 491.536,
    y1: 48.3374,
    x2: 463.941,
    y2: 64.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6029_48873",
    x1: 306.354,
    y1: 185.908,
    x2: 287.496,
    y2: 185.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6029_48873",
    x1: 287.496,
    y1: 179.012,
    x2: 282.439,
    y2: 179.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6029_48873",
    x1: 320.165,
    y1: 183.382,
    x2: 306.354,
    y2: 183.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6029_48873",
    x1: 2350.75,
    y1: 62.3699,
    x2: 2349.83,
    y2: 62.3699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6029_48873",
    x1: 459.864,
    y1: -136.232,
    x2: 432.269,
    y2: -120.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6029_48873",
    x1: 187.542,
    y1: 67.8055,
    x2: 168.684,
    y2: 67.8055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6029_48873",
    x1: 2350.75,
    y1: 60.91,
    x2: 2349.83,
    y2: 60.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6029_48873",
    x1: 2350.75,
    y1: 65.2894,
    x2: 2349.83,
    y2: 65.2894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6029_48873",
    x1: 231.051,
    y1: 86.3149,
    x2: 193.334,
    y2: 86.3149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6029_48873",
    x1: 469.044,
    y1: -93.7644,
    x2: 441.449,
    y2: -77.8097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6029_48873",
    x1: 217.249,
    y1: 91.7505,
    x2: 198.382,
    y2: 91.7505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6029_48873",
    x1: 198.382,
    y1: 84.855,
    x2: 193.334,
    y2: 84.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6029_48873",
    x1: 231.05,
    y1: 89.2247,
    x2: 217.249,
    y2: 89.2247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6029_48873",
    x1: 260.759,
    y1: 111.196,
    x2: 223.033,
    y2: 111.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6029_48873",
    x1: 477.42,
    y1: -48.9426,
    x2: 449.825,
    y2: -32.9879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6029_48873",
    x1: 246.948,
    y1: 116.632,
    x2: 228.09,
    y2: 116.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6029_48873",
    x1: 228.09,
    y1: 109.746,
    x2: 223.033,
    y2: 109.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6029_48873",
    x1: 260.759,
    y1: 114.116,
    x2: 246.948,
    y2: 114.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6029_48873",
    x1: 290.466,
    y1: 131.543,
    x2: 252.741,
    y2: 131.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6029_48873",
    x1: 489.707,
    y1: -15.4972,
    x2: 462.112,
    y2: 0.457524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6029_48873",
    x1: 485.168,
    y1: -12.8811,
    x2: 466.644,
    y2: -2.17097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6029_48873",
    x1: 276.655,
    y1: 136.978,
    x2: 257.788,
    y2: 136.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6029_48873",
    x1: 257.788,
    y1: 130.093,
    x2: 252.741,
    y2: 130.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6029_48873",
    x1: 290.466,
    y1: 134.463,
    x2: 276.656,
    y2: 134.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6029_48873",
    x1: 290.466,
    y1: 102.768,
    x2: 252.741,
    y2: 102.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6029_48873",
    x1: 497.288,
    y1: -37.5131,
    x2: 469.693,
    y2: -21.5584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6029_48873",
    x1: 276.655,
    y1: 108.202,
    x2: 257.788,
    y2: 108.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6029_48873",
    x1: 257.788,
    y1: 101.308,
    x2: 252.741,
    y2: 101.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6029_48873",
    x1: 290.466,
    y1: 105.679,
    x2: 276.656,
    y2: 105.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6029_48873",
    x1: 320.165,
    y1: 154.452,
    x2: 282.439,
    y2: 154.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6029_48873",
    x1: 499.787,
    y1: 24.3773,
    x2: 472.192,
    y2: 40.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6029_48873",
    x1: 306.354,
    y1: 159.897,
    x2: 287.496,
    y2: 159.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6029_48873",
    x1: 287.496,
    y1: 153.001,
    x2: 282.439,
    y2: 153.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D2D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_6029_48873",
    x1: 320.165,
    y1: 157.371,
    x2: 306.354,
    y2: 157.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B65D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A72DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8188E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6029_48873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 437,
    height: 280,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoTitle);
export default __webpack_public_path__ + "static/media/icon-info-title.b23ca0a7d6e9153f989a86fadc95adfe.svg";
export { ForwardRef as ReactComponent };